function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
import React from "react";
export var IconHeart = function IconHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _object_spread({
    width: "100",
    height: "89",
    viewBox: "0 0 100 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M90.7053 9.35674C81.3416 -0.0681321 66.1825 -0.0681321 56.8189 9.35674L50.0007 16.2029L43.1825 9.35674C33.8189 -0.0681321 18.6598 -0.0681321 9.29616 9.35674C-0.0674715 18.7816 -0.0674715 34.0485 9.29616 43.4734L50.0007 84.459L90.7053 43.4734C100.069 34.0485 100.069 18.7816 90.7053 9.35674Z",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round"
  }));
};